<div class="primary-div">

    <div class="screen-options white-card max-auto">
        
        <div class="left-side">
            <div class="screen-title">
                Estatísticas | {{event?.name}} - {{event?.startTime | date: 'dd/MM/yyyy'}}
            </div>
        </div>

        <div style="position: relative;"></div>

    </div>

    <div style="padding: 50px; text-align: center;" *ngIf="!is_loaded" class="max-auto">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </div>

    <div style="padding: 15px 0 0; overflow-x: auto;" *ngIf="is_loaded" class="max-auto">

        <div class="item-card card-graphics">

            <div class="col-info" style="font-weight: 600;">
                <strong> Carro </strong> <br>
               Sócio Antecipado <br>
               Não Sócio Antecipado <br>

                Sócio Evento <br>
               Não Sócio Evento <br>

                
                <span *ngIf="is_admin"> Cortesia </span> <br>
                                 
            </div>

            <div class="col-info">
                <strong> Quantidade </strong> <br>
                <span> 
                    {{event.cars_transaction_partner_count || 0}}
                </span> <br>

                <span> 
                    {{event.cars_transaction_no_partner_count || 0}}
                </span> <br>

                <span>
                    {{event.cars_partner_car_sales_tickets || 0}}
                </span> <br>

                <span>
                    {{event.cars_no_partner_car_sales_tickets || 0}}
                </span> <br>
                
               
                 <span *ngIf="is_admin">
                   {{event.cars_give_away || 0}}  
                </span> <br>
              
            </div>

            <div class="col-info">
                <strong> Preço Unitário </strong> <br>
                <span>
                   {{convertMoney(event.car_partner_price)}}
                </span> <br>

                <span>
                    {{convertMoney(event.car_no_partner_price)}}
                 </span> <br>

                <span>
                  {{convertMoney(event.car_partner_event_price)}}
                </span> <br>

                <span>
                    {{convertMoney(event.car_no_partner_event_price)}}
                  </span> <br>

               
                 <span *ngIf="is_admin">
                    -- 
                </span> <br>         

            </div>
 

            <div class="col-info">
                <b> Total </b> <br>
                {{convertMoney(event.car_transaction_partner_value)}} <br>
                {{convertMoney(event.car_transaction_no_partner_value)}} <br>

                {{convertMoney(event.car_transaction_partner_event_value)}}<br>
                {{convertMoney(event.car_transaction_no_partner_event_value)}}<br>

 
 <span *ngIf="is_admin"> -- </span>
                
                
            </div>

        </div>

        

        <div class="item-card card-graphics">

            <div class="col-info" style="font-weight: 600;">
                <strong> Ônibus </strong> <br>
               Sócio Antecipado <br>
               Não Sócio Antecipado <br>

                Sócio Evento <br>
               Não Sócio Evento <br>

                
                <span *ngIf="is_admin"> Cortesia </span> <br>
                                 
            </div>

            <div class="col-info">
                <strong> Quantidade </strong> <br>
                <span> 
                    {{event.bus_transaction_partner_count}}
                </span> <br>

                <span> 
                    {{event.bus_transaction_no_partner_count}}
                </span> <br>

                <span>
                    {{event.bus_partner_bus_sales_tickets}}
                </span> <br>

                <span>
                    {{event.bus_no_partner_bus_sales_tickets}}
                </span> <br>
                
               
                 <span *ngIf="is_admin">
                   {{event.bus_give_away}}  
                </span> <br>
              
            </div>

            <div class="col-info">
                <strong> Preço Unitário </strong> <br>
                <span>
                   {{convertMoney(event.bus_partner_price)}}
                </span> <br>

                <span>
                    {{convertMoney(event.bus_no_partner_price)}}
                 </span> <br>

                <span>
                  {{convertMoney(event.bus_partner_event_price)}}
                </span> <br>

                <span>
                    {{convertMoney(event.bus_no_partner_event_price)}}
                  </span> <br>

               
                 <span *ngIf="is_admin">
                    --  
                </span> <br>         

            </div>
 

            <div class="col-info">
                <b> Total </b> <br>
                {{convertMoney(event.bus_transaction_partner_value)}} <br>
                {{convertMoney(event.bus_transaction_no_partner_value)}} <br>

                {{convertMoney(event.bus_transaction_partner_event_value)}}<br>
                {{convertMoney(event.bus_transaction_no_partner_event_value)}}<br>

 
 <span *ngIf="is_admin"> -- </span>
                
                
            </div>

        </div>

        <div class="item-card card-graphics">

            <div class="col-info" style="font-weight: 600;">
                <strong> Van </strong> <br>
               Sócio Antecipado <br>
               Não Sócio Antecipado <br>

                Sócio Evento <br>
               Não Sócio Evento <br>

                
                <span *ngIf="is_admin"> Cortesia </span> <br>
                                 
            </div>

            <div class="col-info">
                <strong> Quantidade </strong> <br>
                <span> 
                    {{event.van_transaction_partner_count}}
                </span> <br>

                <span> 
                    {{event.van_transaction_no_partner_count}}
                </span> <br>

                <span>
                    {{event.van_partner_van_sales_tickets}}
                </span> <br>

                <span>
                    {{event.van_no_partner_van_sales_tickets}}
                </span> <br>
                
               
                 <span *ngIf="is_admin">
                   {{event.van_give_away}}  
                </span> <br>
              
            </div>

            <div class="col-info">
                <strong> Preço Unitário </strong> <br>
                <span>
                   {{convertMoney(event.van_partner_price)}}
                </span> <br>

                <span>
                    {{convertMoney(event.van_no_partner_price)}}
                 </span> <br>

                <span>
                  {{convertMoney(event.van_partner_event_price)}}
                </span> <br>

                <span>
                    {{convertMoney(event.van_no_partner_event_price)}}
                  </span> <br>

               
                 <span *ngIf="is_admin">
                    --
                </span> <br>         

            </div>
 

            <div class="col-info">
                <b> Total </b> <br>
                {{convertMoney(event.van_transaction_partner_value)}} <br>
                {{convertMoney(event.van_transaction_no_partner_value)}} <br>

                {{convertMoney(event.van_transaction_partner_event_value)}}<br>
                {{convertMoney(event.van_transaction_no_partner_event_value)}}<br>

 
 <span *ngIf="is_admin"> -- </span>
                
                
            </div>

        </div>

        

    </div>

</div>